module.exports = __webpack_public_path__ + "img/police-box.80ebb272.svg";